import { type ForkPageCountry, type ForkPageNavigationProps } from "~/pages/ForkPage/ForkPage";
import { Link } from "~/common/components/Link";
import { Accordion, AccordionDetails, AccordionSummary } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "~/features/categoryNavigation/components/LanguageSelector";

export const MobileForkPageNavigation = ({ subtitle, regions }: ForkPageNavigationProps) => {
  const { t } = useTranslation();
  const makeLink = ({ title, url, openInNewTab }: ForkPageCountry) => (
    <Link key={title} href={url} target={openInNewTab ? "_blank" : undefined}>
      {t(title)}
    </Link>
  );

  return (
    <div>
      <h2 className="scha__fork__subtitle">{subtitle}</h2>

      <div className={"scha__fork__mobile-regions"}>
        {regions.map((region) => {
          const countriesPerColumn = Math.floor((region.countries.length + 1) / 2);

          return (
            <Accordion>
              <AccordionSummary>{t(region.title)}</AccordionSummary>
              <AccordionDetails>
                <div className="scha__fork__region__countries">
                  <div className="scha__fork__region__countries__column">
                    {region.countries.slice(0, countriesPerColumn).map(makeLink)}
                  </div>

                  {region.countries.length > countriesPerColumn && (
                    <div className="scha__fork__region__countries__column">
                      {region.countries.slice(countriesPerColumn).map(makeLink)}
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
      <hr className="scha__fork__underline fullbleed" />
      <LanguageSelector />
    </div>
  );
};
